/* Kennt die Datenbank die Spalten für den Vereins-Verweis schon?
 *
 * Die Spalten players.current_club_id, player_transfers.from_club_id und to_club_id entstehen mit
 * supabase/klubregister-4-spalten.sql (B1). Die App muss VOR und NACH diesem Skript laufen (Auftrag 7, Phase 2):
 *   - Lesen: select('*') liefert die Spalten, sobald es sie gibt. Fehlt der Schlüssel in einer gelesenen Zeile,
 *     gibt es sie noch nicht; die App benutzt dann nur den Text.
 *   - Schreiben: Wir versuchen es mit den Spalten; meldet die Datenbank eine unbekannte Spalte, wird derselbe
 *     Schreibvorgang OHNE sie wiederholt (und für den Rest der Sitzung ohne sie geschrieben). Es geht nichts
 *     verloren: Der Text steht immer mit im Datensatz (Übergangsregel).
 * Der Zustand gilt je Sitzung (Modulbereich); ein Neuladen der Seite prüft neu.
 */

import { isMissingClubColumn } from '../domain/footballClub.js';

const PROBE = { players: 'current_club_id', transfers: 'from_club_id' };
/* null = unbekannt, true = Spalten vorhanden, false = fehlen */
const known = { players: null, transfers: null };

/** Eine gelesene Zeile auswerten: trägt sie die Spalte? */
export function noteClubColumns(table, row) {
  if (!row || typeof row !== 'object') return;
  known[table] = PROBE[table] in row;
}

/** Zustand für Tests und Diagnose */
export function clubColumnsKnown(table) {
  return known[table];
}

export function resetClubColumns() {
  known.players = null;
  known.transfers = null;
}

/**
 * Schreiben mit Rückfall. exec(row) führt den Schreibvorgang aus und liefert { data, error }.
 * withIds enthält die Verweis-Spalten, withoutIds nicht.
 */
export async function writeWithClubColumns(table, withIds, withoutIds, exec) {
  if (known[table] !== false) {
    const res = await exec(withIds);
    if (!res.error) {
      known[table] = true;
      return res;
    }
    if (!isMissingClubColumn(res.error)) return res;
    known[table] = false;
    console.warn(`[clubColumns] ${table}: Spalten für den Vereins-Verweis fehlen noch (klubregister-4-spalten.sql) — es wird ohne sie gespeichert.`);
  }
  return exec(withoutIds);
}
